/**
 * Compact page trail matching the main-app dashboard breadcrumb
 * (`Dashboard > Home`): muted parent, current page in body ink.
 */
export default function PageBreadcrumb({
  rootLabel = 'Portal',
  currentLabel,
  onRootClick,
  t,
  className = '',
}) {
  return (
    <nav
      aria-label="Breadcrumb"
      className={`flex items-center gap-1.5 min-h-11 text-[13px] ${className}`}
      style={{ fontFamily: t.fonts.body }}
    >
      {onRootClick ? (
        <button
          type="button"
          onClick={onRootClick}
          className={`inline-flex items-center min-h-[44px] rounded focus:outline-none focus-visible:ring-2 ${t.focusRing} hover:underline`}
          style={{ color: t.muted }}
        >
          {rootLabel}
        </button>
      ) : (
        <span style={{ color: t.muted }}>{rootLabel}</span>
      )}
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        className="h-3 w-3 shrink-0"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ color: t.muted }}
      >
        <path d="M9 18l6-6-6-6" />
      </svg>
      <h1
        className="min-w-0 truncate text-[13px] font-semibold leading-none"
        style={{ color: t.heading, fontFamily: t.fonts.body, fontWeight: 600 }}
      >
        {currentLabel}
      </h1>
    </nav>
  );
}
